import { IAction } from '@src/interfaces';
import Data from '@utils/BaseData';
import React from 'react';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

const useApi = (dispatch: React.Dispatch<IAction>) => {

  const api = {

    getSubDomain(): string {
      const sub_domain = location.hostname.indexOf('dev') >= 0
        ? 'dev'
        : location.hostname.indexOf('qa') >= 0
          ? 'qa'
          : '';
      return sub_domain;
    },

    isReallyLoading(...args: Array<string>): boolean {
      return Data.isReallyLoading(...args);
    },

    parseResult(res: any): any {
      return JSON.parse(JSON.parse(res.text).result);
    },

    getApps(domain: string): Promise<void> {
      const fn = 'getApps';
      return Data.post('/api/users/do/get_apps_list?start', fn,
        { home: true, domain })
        .then((res: any) => {
          dispatch({ type: 'SET_APPS', data: api.parseResult(res) });
        });
    },

    getManage(domain: string): Promise<void> {
      const fn = 'getManage';
      return Data.post('/api/users/do/get_manage_list?start', fn,
        { home: true, domain })
        .then((res: any) => {
          dispatch({ type: 'SET_MANAGE', data: api.parseResult(res) });
        });
    },

    getWidgets(domain: string): Promise<void> {
      const fn = 'getWidgets';
      return Data.post('/api/widget/do/get_my_widgets?start', fn,
        { home: true, domain })
        .then((res: any) => {
          dispatch({ type: 'SET_WIDGETS', data: JSON.parse(res.text).result });
        });
    },

    getPermissions(): Promise<void> {
      const fn = 'getPermissions';
      return Data.post('/api/users/do/get_permissions?start', fn,
        { nosession: true })
        .then((res: any) => {
          dispatch({ type: 'SET_PERMISSIONS', data: api.parseResult(res) });
        });
    },

    getCookieDomain() {
      return window.location.hostname.split('.').map((part, idx) => {
        return idx > 0 ? part : ''
      }).join('.');
    },

    tempCookie() {
      return {
        path: '/',
        domain: api.getCookieDomain(),
        secure: true,
        strict: true
      };
    },

    yearCookie() {
      const dt = new Date();
      const next_year = new Date(dt.setFullYear(dt.getFullYear() + 1));
      return {
        expires: next_year,
        path: '/',
        domain: api.getCookieDomain(),
        secure: true,
        strict: true
      };
    },

    login(username: string, password: string): Promise<void> {
      cookies.remove('oasis_priorsession' + api.getSubDomain(), api.tempCookie());
      cookies.remove('oasis_displayname' + api.getSubDomain(), api.tempCookie());

      const fn = 'login';
      return Data.post('/api/users/do/login_info', fn,
        { nosession: true, user_name: username, password: password })
        .then((res: any) => {
          const data = api.parseResult(res);
          if (data.session_guid) {
            api.getSession(data.session_guid);
          }
          dispatch({ type: 'SET_LOGIN', data });
        });
    },

    logout(): Promise<void> {
      const fn = 'logout';
      return Data.post('/api/users/do/logout', fn,
        {})
        .then(() => {
          cookies.remove('oasis_session', api.tempCookie());
          cookies.remove('oasis_session' + api.getSubDomain(), api.tempCookie());
          cookies.remove('oasis_displayname' + api.getSubDomain(), api.tempCookie());
          cookies.remove('oasis_env', api.tempCookie());
          cookies.remove('oasis_lastname' + api.getSubDomain(), api.tempCookie());
          cookies.remove('oasis_userid' + api.getSubDomain(), api.tempCookie());
          cookies.remove('oasis_impersonated' + api.getSubDomain(), api.tempCookie());
          if (cookies.get('oasis_priorsession' + api.getSubDomain())) {
            api.getSession(cookies.get('oasis_priorsession' + api.getSubDomain()));
            cookies.remove('oasis_priorsession' + api.getSubDomain(), api.tempCookie());
            dispatch({ type: 'SET_REAL_USER' });
          }
          else {
            dispatch({ type: 'SET_SESSION', data: { nosession: true } });
          }
        });
    },

    getSession(guid: string, impersonate?: boolean): Promise<void> {
      const fn = 'getSession';

      if (guid) {
        if (impersonate) {
          cookies.set('oasis_priorsession' + api.getSubDomain(), cookies.get('oasis_session' + api.getSubDomain()), api.tempCookie());
          cookies.set('oasis_impersonated' + api.getSubDomain(), true, api.tempCookie());
        }
        // console.log(api.getSubDomain());
        cookies.set('oasis_session', guid, api.tempCookie());
        cookies.set('oasis_session' + api.getSubDomain(), guid, api.tempCookie());
      }
      return Data.post('/api/users/do/get_session_info?login=true', fn,
        guid ? { nosession: true, session_guid: guid } : {})
        .then((res: any) => {
          // console.log('res', res);
          if (res) {
            const data = api.parseResult(res);
            // console.log('data', data);
            const oasis_name_key = 'oasis_name' + api.getSubDomain() + '[' + guid + ']';
            const oasis_name_value = (data.display_name ? data.display_name : '') + ' (' + data.login_user_name + ')';
            const temp = api.tempCookie();
            // console.log('oasis_name_key', oasis_name_key);
            // console.log('oasis_name_value', oasis_name_value);
            // console.log('temp', temp);
            cookies.set(oasis_name_key, oasis_name_value, temp);
            // console.log('a');
            cookies.set('oasis_displayname' + api.getSubDomain(), (data.display_name ? data.display_name : '') + ' (' + data.login_user_name + ')', api.tempCookie());
            // console.log('b');
            cookies.set('oasis_username', data.user_name, api.yearCookie());
            // console.log('c');
            cookies.set('oasis_username' + api.getSubDomain(), data.user_name, api.yearCookie());
            // console.log('d');
            cookies.set('oasis_lastname' + api.getSubDomain(), data.last_name, api.tempCookie());
            // console.log('e');
            cookies.set('oasis_userid' + api.getSubDomain(), data.user_id, api.tempCookie());
            // console.log('f');
            cookies.set('oasis_env', api.getSubDomain(), api.tempCookie());
            // console.log('g');
            if (!impersonate) {
              cookies.set('oasis_login_username' + api.getSubDomain(), data.login_user_name, api.yearCookie());
            }
            // console.log('h');
            dispatch({ type: 'SET_SESSION', data: data, impersonating: impersonate });
            // console.log('i');
          } else {
            // console.log('j');
            dispatch({ type: 'SET_SESSION', data: { nosession: true } });
            // console.log('k');
          }
          api.cleanUpCookies();
        }).catch((reason) => {
          console.log('ERROR', reason);
        });
    },

    cleanUpCookies() {
      if (!cookies.get('oasis_impersonated' + api.getSubDomain())) {
        Object.keys(cookies.getAll()).filter((key) => {
          return key.indexOf('oasis_name' + api.getSubDomain() + '[') >= 0;
        }).filter((key) => {
          return key.indexOf('oasis_name' + api.getSubDomain() + '[' + cookies.get('oasis_session' + api.getSubDomain()) + ']') < 0;
        }).forEach((key) => {
          cookies.remove(key, api.tempCookie());
        });
      }
    },

    getArticles(path: string): Promise<void> {
      const fn = 'getArticles';
      return Data.post('/api/page/do/get_path_articles', fn,
        { nosession: true, path })
        .then((res: any) => {
          dispatch({ type: 'SET_ARTICLES', data: api.parseResult(res) });
        });
    },

    getNotice(): Promise<void> {
      const fn = 'getNotice';
      return Data.post('/api/page/do/get_notice', fn,
        { nosession: true })
        .then((res: any) => {
          dispatch({ type: 'SET_NOTICE', data: JSON.parse(res.text).result });
        });
    },

    getOrgs(page: number | null | undefined, domain: string, search?: string | null, parent?: number | null): Promise<void> {
      const fn = 'getOrgs';
      return Data.post('/api/custom_orgs/do/get_quick_list', fn,
        { nosession: true, page: page || 1, search: search, parent_org_id: parent, domain }, false, true)
        .then((res: any) => {
          dispatch({ type: 'SET_ORGS', data: api.parseResult(res) });
        });
    },

    sendRequest(org_id: number, domain: string, first_name: string, last_name: string,
      phone_number: string, email: string, captcha: string): Promise<void> {
      const fn = 'sendRequest';
      return Data.post('/api/users/do/get_started', fn,
        {
          nosession: true,
          org_id: org_id,
          first_name: first_name,
          last_name: last_name,
          phone_number: phone_number,
          email: email,
          captcha: captcha,
          domain
        })
        .then((res: any) => {
          dispatch({ type: 'SET_REQUESTED', data: { message: JSON.parse(res.text).result } });
        });
    },

    sendMessage(message_text: string, first_name: string, last_name: string, phone_number: string,
      email: string, captcha: string, domain: string): Promise<void> {
      const fn = 'sendMessage';
      return Data.post('/api/users/do/contact_admin', fn,
        {
          nosession: true,
          message_text: message_text,
          first_name: first_name,
          last_name: last_name,
          phone_number: phone_number,
          email: email,
          captcha: captcha,
          domain
        })
        .then((res: any) => {
          dispatch({ type: 'SET_REQUESTED', data: { message: JSON.parse(res.text).result } });
        });
    },

    changePassword(old_password: string, new_password: string): Promise<void> {
      const fn = 'changePassword';
      return Data.post('/api/users/do/change_my_password', fn,
        {
          old_password: old_password,
          new_password: new_password
        })
        .then((res: any) => {
          dispatch({ type: 'DONE_CHANGE_PASSWORD', data: JSON.parse(res.text) });
        });
    },

    setPassword(email: string, token: string, new_password: string): Promise<void> {
      const fn = 'setPassword';
      return Data.post('/api/users/do/set_password', fn,
        {
          nosession: true,
          email: email,
          token: token,
          new_password: new_password
        })
        .then((res: any) => {
          dispatch({ type: 'DONE_CHANGE_PASSWORD', data: JSON.parse(res.text) });
        });
    },

    sendPassword(email: string, domain: string): Promise<void> {
      const fn = 'sendPassword';
      return Data.post('/api/users/do/forgot_password', fn,
        { nosession: true, email, domain })
        .then((res: any) => {
          dispatch({ type: 'PASSWORD_SENT', data: JSON.parse(res.text).result });
        });
    },

    getUsers(page?: number, search?: string): Promise<void> {
      const fn = 'getUsers';
      return Data.post('/api/users/do/get_quick_list', fn,
        { page: page || 1, search: search }, false, true)
        .then((res: any) => {
          dispatch({ type: 'SET_USERS', data: api.parseResult(res) });
        });
    },

    impersonate(user_id: number): Promise<void> {
      const fn = 'impersonate';
      return Data.post('/api/users/do/get_other_session', fn,
        { user_id: user_id, id: 123456 }, false, true)
        .then((res: any) => {
          if (res && res.text) {
            if (JSON.parse(res.text).result) {
              api.getSession(JSON.parse(res.text).result, true);
            }
          }
        });
    },

    getSearch(type: string, page?: number, search?: string): Promise<void> {
      const fn = 'getSearch';
      return Data.get('/palmtree/index/data', fn,
        {
          page: page || 1,
          search_text: search,
          object_type: type,
          type: 'search',
          scope: 'super_search',
          page_size: 10
        }, false, true)
        .then((res: any) => {
          const nodes = JSON.parse(res.text);
          nodes.count = nodes.node_count;
          dispatch({ type: 'SET_SEARCH', data: nodes });
        });
    }

  }
  return api;
};

export default useApi;